import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DensityLargeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"density_large"}/>
}
